var moment = require('moment');
var React = require( 'react' );
var createReactClass = require('create-react-class');
var Link = require('react-router').Link;
var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var Modal = require('./modal.jsx');
var modalActions = require('../../../modules/modals/actions/modal');
var latestHpiActions = require('../../../modules/dashboard/actions/latestHpi');

var BeforeSendHpiModal = createReactClass({

  onClose: function() {
    this.props.hideModal();
  },

  componentWillReceiveProps: function(nextProps){
      if(nextProps.isHpiSent && nextProps.isHpiSent !== this.props.isHpiSent){
          this.onClose();
      }
  },

  handleSend2Doctor: function(){
      this.onClose();
      this.props.sendHpi2Doctor(this.props.token);
  },

  render: function() {
    var id = this.props.modal.props.id || 'beforeSendHpi';

    return (
      <Modal onClose={this.onClose} id={id}>
          <h3>Update Your Information</h3>
          <p>The name and date of birth you provide to MyGiHealth must match your doctor's records.</p>

          <p className="profile-card">
              <span className="name">{this.props.profile.firstName + ' ' + this.props.profile.lastName}</span>
              <span className="meta">{moment(this.props.profile.dateOfBirth).format('MM / DD / YYYY')}</span>
          </p>
          <p className="actions">
              <button className="button success" type="button" onClick={this.handleSend2Doctor}>Continue and Submit</button>
              <Link className="button secondary" to="/profile">Edit Account Name</Link>
              <a className="cancel button" onClick={this.onClose}>Cancel</a>
          </p>
      </Modal>
    );
  }

});

var mapStateToProps = function(state){
    return {
        token: state.auth.token,
        profile: state.profile.data,
        isHpiSent: state.dashboard.isHpiSent
    };
}

var mapDispatchToProps = function(dispatch) {
  return bindActionCreators(Object.assign({}, modalActions, latestHpiActions), dispatch);
}

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(BeforeSendHpiModal);



// WEBPACK FOOTER //
// ./src/common/routes/components/modals/beforeSendHpiModal.jsx